function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { jsx, css, Global } from '@emotion/react';
import { useMemo } from 'react';
import { assets as assetsCSS, evergreen as evergreenCSS, forms as formsCSS, formsEvergreen as formsEvergreenCSS, page as pageCSS, reduceMotion as reduceMotionCSS, sanitize as sanitizeCSS, typography as typographyCSS } from './styles';

var createStyle = function createStyle(props) {
  var assets = props.assets,
      evergreen = props.evergreen,
      forms = props.forms,
      formsEvergreen = props.formsEvergreen,
      page = props.page,
      reduceMotion = props.reduceMotion,
      sanitize = props.sanitize,
      typography = props.typography;
  return css(_templateObject(), assets ? assetsCSS : '', evergreen ? evergreenCSS : '', forms ? formsCSS : '', formsEvergreen ? formsEvergreenCSS : '', page ? pageCSS : '', reduceMotion ? reduceMotionCSS : '', sanitize ? sanitizeCSS : '', typography ? typographyCSS : '');
};

var SanitizeCSS = function SanitizeCSS(_ref) {
  var _ref$assets = _ref.assets,
      assets = _ref$assets === void 0 ? false : _ref$assets,
      _ref$evergreen = _ref.evergreen,
      evergreen = _ref$evergreen === void 0 ? false : _ref$evergreen,
      _ref$forms = _ref.forms,
      forms = _ref$forms === void 0 ? false : _ref$forms,
      _ref$formsEvergreen = _ref.formsEvergreen,
      formsEvergreen = _ref$formsEvergreen === void 0 ? false : _ref$formsEvergreen,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? false : _ref$page,
      _ref$reduceMotion = _ref.reduceMotion,
      reduceMotion = _ref$reduceMotion === void 0 ? false : _ref$reduceMotion,
      _ref$sanitize = _ref.sanitize,
      sanitize = _ref$sanitize === void 0 ? true : _ref$sanitize,
      _ref$typography = _ref.typography,
      typography = _ref$typography === void 0 ? false : _ref$typography;
  var style = useMemo(function () {
    return createStyle({
      assets: assets,
      evergreen: evergreen,
      forms: forms,
      formsEvergreen: formsEvergreen,
      page: page,
      reduceMotion: reduceMotion,
      sanitize: sanitize,
      typography: typography
    });
  }, [assets, evergreen, forms, formsEvergreen, page, reduceMotion, sanitize, typography]);
  return jsx(Global, {
    styles: style
  });
};

export { SanitizeCSS };